var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"text-transform":"uppercase"},attrs:{"plain":"","to":_vm.channelURL}},[_vm._v(" "+_vm._s(_vm.$t('dashboard.myChannel'))+" "),_c('v-icon',{staticClass:"ml-2"},[_vm._v("video_camera_front")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }